import { SummaryMetadata } from 'generated/graphql';

export const getFirstLastMsgIndicesFromSummaryMetadata = (
  metadata: SummaryMetadata | undefined,
) => {
  const firstSummaryLocation = metadata?.location?.[0];
  const lastSummaryLocation =
    metadata?.location?.[metadata?.location?.length - 1];

  if (firstSummaryLocation?.__typename !== 'IndexTypeConversation') {
    return {
      firstMsgIndex: 0,
      lastMsgIndex: 0,
    };
  }

  const firstMsgIndex = firstSummaryLocation.messageIndex;
  const lastMsgIndex =
    firstSummaryLocation.messageEndIndex ??
    (lastSummaryLocation?.__typename === 'IndexTypeConversation'
      ? lastSummaryLocation.messageIndex
      : 0);

  return {
    firstMsgIndex,
    lastMsgIndex,
  };
};
